import React, {Component} from 'react'
import {Header, Features, WhatsNew, Footer, Partners} from '../../containers'
import { Navbar } from '../../components';
import './home.css'

export default class Home extends Component {

    componentDidMount(){
        document.title = "Greymate Care - Welcome";
    }
    render(){
        return (
            <div className="App">
                <Navbar/>
                <Header />
                <Partners />
                <Features />
                <WhatsNew/>
                <Footer />
            </div>
        );
    }
}